module.exports = __webpack_public_path__ + "static/media/sel_04_228.d3c8e105.mp4";